// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"50c09312","141":"3f77c590","388":"88b4db35","451":"6a7c53ca","856":"67a6b287"}[chunkId] + ".chunk.js";
};